import './app-config';
import { angularCoreConfigModule } from '../../../shared/app/config/angular-core';
import { loadingBarConfigModule } from '../../../shared/app/config/loading-bar';
import { appConfigModule } from '../../../shared/app/constants/app-config';

export const configModule = angular.module('Q.config', [
  appConfigModule,
  angularCoreConfigModule,
  loadingBarConfigModule,
]);
